export default "__VITE_ASSET__ee5e903c__"